<template>
    <!-- Demo client (client.id === 0) CTA: "See my data" / Schedule a Demo -->
    <div class="row mt-3 px-0 mx-0 cta-container" v-if="client && client.id == 0">
        <div class="col-12 px-0">
            <div class="card px-0">
                <div class="card-body py-5 px-0">
                    <div class="cta-overflow-wrapper">
                        <div class="cta-content-row">
                            <!-- Left side - 2 images -->
                            <div class="cta-side-group left d-none d-lg-flex">
                                <img src="/img/images/benchmarks-chart-1.png" class="cta-chart-img" alt="Benchmark Chart 1">
                                <img src="/img/images/benchmarks-chart-2.png" class="cta-chart-img" alt="Benchmark Chart 2">
                            </div>

                            <!-- Center - Text content -->
                            <div class="cta-center-content text-center px-4">
                                <div class="d-flex justify-content-center mb-3">
                                    <img src="/img/icons/nav-icons/Benchmarks.svg" alt="Benchmark" class="icon" style="height: 60px;">
                                </div>
                                <p class="mb-2">Your performance.</p>
                                <h2 class="mb-3">Benchmarked.</h2>
                                <p class="mb-2">
                                    Meet with an Avid Fundraising Expert to see how your results<br>
                                    stack up and what your next moves could be.
                                </p>
                                <a href="#" class="btn btn-secondary" @click.prevent="openDemoModal">
                                    See my data
                                </a>
                            </div>

                            <!-- Right side - 2 images -->
                            <div class="cta-side-group right d-none d-lg-flex">
                                <img src="/img/images/benchmarks-chart-3.png" class="cta-chart-img" alt="Benchmark Chart 3">
                                <img src="/img/images/benchmarks-chart-4.png" class="cta-chart-img" alt="Benchmark Chart 4">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Schedule Demo Modal -->
    <ScheduleDemoModal
        ref="scheduleDemoModal"
        :user="user"
        :client="client"
        :instance-id="instanceId"
    />
</template>

<script>
import { defineComponent } from 'vue';
import ScheduleDemoModal from '../components/ScheduleDemoModal.vue';

export default defineComponent({
    name: 'BenchmarkViewWilandDemoCta',
    components: {
        ScheduleDemoModal
    },
    props: {
        user: {
            type: [Object, null],
            default: null
        },
        client: {
            type: [Object, null],
            default: null
        }
    },
    data() {
        return {
            instanceId: 'cta-' + Math.random().toString(36).slice(2, 9)
        };
    },
    methods: {
        openDemoModal() {
            if (this.$refs.scheduleDemoModal) {
                this.$refs.scheduleDemoModal.openModal();
            }
        }
    }
});
</script>
